import _ from 'lodash';
import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PhoneIcon from '@mui/icons-material/Phone';
import { EMAIL_REGEX, PHONE_NUMBER_REGEX } from '../../../utility/inputUtils';

interface ITextFieldWitLinkProps extends Omit<TextFieldProps, 'value'> {
  linkType: 'email' | 'phone';
  value: string;
}

// It defines which icon to use for each linkType
const ICON_MAP = {
  email: MailOutlineIcon,
  phone: PhoneIcon,
};

// It defines which regex to use for each linkType
const REGEX_MAP = {
  email: EMAIL_REGEX,
  phone: PHONE_NUMBER_REGEX,
};

const HREF_MAP = {
  email: 'mailto:',
  phone: 'tel:',
};

const validateWithRegex = (text: string, regex: RegExp): boolean => {
  if (_.isEmpty(text)) return false;

  return regex.test(text);
};

export default function TextFieldWithLink({
  linkType,
  value,
  ...rest
}: ITextFieldWitLinkProps) {
  const regex = REGEX_MAP[linkType];
  const isValid = validateWithRegex(value, regex);
  const hrefPrefix = HREF_MAP[linkType];
  const RenderIcon = ICON_MAP[linkType];

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <TextField
        value={value}
        {...rest}
      />
      <Link
        to={isValid ? `${hrefPrefix}${value}` : ''}
        style={{ alignContent: 'center', pointerEvents: isValid ? 'auto' : 'none' }}
      >
        <RenderIcon sx={{ color: isValid ? 'black' : 'grey' }} />
      </Link>
    </Box>
  );
}
